import { IDEA_CATEGORIES } from "@src/store/slices/experienceBuilder/ideas";
import type {
  IdeaCategory,
  IdeaCategoryFilter,
} from "@src/store/slices/experienceBuilder/ideas";

/** Sidebar entries: the "all" pseudo-category first, then the real categories. */
export const SIDEBAR_CATEGORIES: { id: IdeaCategoryFilter; label: string }[] = [
  { id: "all", label: "All content prompts" },
  ...IDEA_CATEGORIES,
];

/** Category id → label, for the badge on a searched result. */
export const CATEGORY_LABELS: Record<IdeaCategory, string> = Object.fromEntries(
  IDEA_CATEGORIES.map((c) => [c.id, c.label])
) as Record<IdeaCategory, string>;
